var ukey = IS.crypt.MD5("username" + IS.device.getUUID());
var tkey = IS.crypt.MD5("token" + IS.device.getUUID());
var REGENERATE_TOKEN_SECONDS_BEFORE_INVALIDATION = 60 * 15; //15 minutes

var iScreenWizard = angular
    .module("iScreenWizard", [
        "ISAppHelper.angular",
        "ui.router",
        "ngSanitize",
        "ngMaterial",
        "md.data.table",
        "angularTrix",
        "checklist-model",
    ])

    .config(function ($mdThemingProvider, $mdDateLocaleProvider) {
        Trix.config.blockAttributes.default.tagName = "p";
        const greenColorScheme = $mdThemingProvider.extendPalette("green", {
            50: "#6cbea8",
            100: "#6cbea8",
            200: "#6cbea8",
            300: "#6cbea8",
            400: "#6cbea8",
            500: "#6cbea8",
            600: "#6cbea8",
            700: "#6cbea8",
            800: "#6cbea8",
            900: "#6cbea8",
            A100: "#6cbea8",
            A200: "#6cbea8",
            A400: "#6cbea8",
            A700: "#6cbea8",
            contrastDefaultColor: "light",
        });

        $mdThemingProvider.definePalette("green", greenColorScheme);

        $mdThemingProvider
            .theme("default")
            .primaryPalette("deep-orange")
            .accentPalette("green");

        $mdDateLocaleProvider.formatDate = function (date) {
            return date ? moment(date).format("DD-MM-YYYY") : "";
        };

        $mdDateLocaleProvider.parseDate = function (dateString) {
            var m = moment(dateString, "DD-MM-YYYY", true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    });
